import { MAX_LIGHTBOX_IMAGE_WIDTH } from '../constants';
import type { GalleryImage } from '../ImageGallery.common';

import { useDeviceWidth, useImageSize } from './index';
import { ImageSize } from './useImageSize.common';

interface UseImageGalleryOptions {
  totalImageCount?: number;
}

export interface UseImageGalleryReturn {
  currentUri: string;
  currentSize: ImageSize;
  isCurrentImageFirst: boolean;
  isCurrentImageLast: boolean;
  hasNextImage: boolean;
  hasPrevImage: boolean;
  currentIndex: number;
}

export const useImageGallery = (
  images: GalleryImage[] | undefined,
  lightboxIndex: number,
  options?: UseImageGalleryOptions
): UseImageGalleryReturn => {
  const deviceWidth = useDeviceWidth();
  const totalCount = options?.totalImageCount ?? images?.length ?? 0;

  let currentUri = '';
  if (images) {
    currentUri = images[lightboxIndex]?.largeUncropped;
  }
  const currentSize = useImageSize(currentUri, deviceWidth, MAX_LIGHTBOX_IMAGE_WIDTH);

  const isCurrentImageFirst = lightboxIndex === 0;
  const isCurrentImageLast = images ? lightboxIndex === totalCount - 1 : false;
  const hasNextImage = images ? lightboxIndex < totalCount - 1 : false;
  const hasPrevImage = lightboxIndex > 0;

  return {
    currentUri,
    currentSize,
    isCurrentImageFirst,
    isCurrentImageLast,
    hasNextImage,
    hasPrevImage,
    currentIndex: lightboxIndex,
  };
};
